import type { ReactNode } from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@rocco/components/tooltip';

interface TextTooltipProps {
    className?: string;
    content: string;
    children: ReactNode;
    delayDuration?: number;
}

export function TextTooltip({
    className,
    content,
    children,
    delayDuration = 300,
}: TextTooltipProps) {
    if (!content) return <>{children}</>;

    return (
        <TooltipProvider delayDuration={delayDuration}>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent side="top" color="dark" className={className}>
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
